<script>
    export let data;
    let moving = 'start';
    let heroSlides = 'start-slide';
    /**
     *
     */
    function btnfun() {
        if (data[0].description === '') {
            if (moving == 'start') {
                moving = 'start-slide';
            } else if (moving == 'start-slide') {
                moving = 'next-slide';
            } else {
                moving = 'start';
            }
        } else {
            if (heroSlides == 'start-slide') {
                heroSlides = 'next-slide';
            } else {
                heroSlides = 'start-slide';
            }
        }
    }
</script>

<section>
    <div class="desktop" style="position: relative;">
        <div class="border-div" />
        <div class="hero-div">
            <p class="hero-text">3100+ Heroes</p>
        </div>
        <div class="raised-div">
            <p class="hero-text">$900M+ Raised</p>
        </div>
        <div class="slider">
            {#if data[0].description === ''}
                {#each data as data}
                    <div class="sli {moving}">
                        <div class="slider-img">
                            <img src={data.image} alt="" width="100%" />
                        </div>
                        <div>
                            <div class="line-one">
                                <div class="name-text">
                                    <p class="name-text">{data.person_name}</p>
                                </div>
                                <div
                                    class="logo-img"
                                    style="width:{data.width}; margin-right:{data.logo_right_margin}; "
                                >
                                    <img src={data.company_logo} alt="" />
                                </div>
                            </div>
                            <div class="line-two">
                                <p class="date">{data.date}</p>
                                <div style="min-width: 4vw;text-align: center;">
                                    <p class="logo-text">{data.company_name}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                {/each}
            {:else}
                {#each data as data}
                    <div class="sli {heroSlides}">
                        <div class="slider-img">
                            <img src={data.image} alt="" width="100%" />
                        </div>
                        <div
                            style="margin-top: 1.560vw; display: flex; flex-direction:row; align-items: center; justify-content:space-between;"
                        >
                            <div
                                style="display: flex; flex-direction:column; gap:1.323vw;"
                            >
                                <div>
                                    <p
                                        class="name-text"
                                        style="width: 10vw;font-weight: 400;
                                    color: rgba(0, 32, 75, 1);"
                                    >
                                        {data.person_name}
                                    </p>
                                </div>
                                <div>
                                    <p
                                        style="
                                        font-size: 1.058vw;
                                        font-weight: 300;
                                        margin: 0vw;
                                        font-weight:500;
                                        color: rgba(0, 32, 75, 0.7);"
                                        
                                    >
                                        {@html data.description}
                                    </p>
                                </div>
                            </div>
                            <div>
                                <div
                                    class="logo-img"
                                    style="width:{data.width}; margin-right:{data.logo_right_margin}; margin-top:{data.logo_top_margin} "
                                >
                                    <img src={data.company_logo} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                {/each}
            {/if}

            <div
                class="next-btn"
                on:click={() => {
                    btnfun();
                }}
            >
                <img
                    src="images/fundamental_programs/next_button.svg"
                    alt=""
                    width="100%"
                />
            </div>
        </div>
    </div>
</section>

<style>
    .start {
        transform: translate(-112vw);
        opacity: 1;
    }
    .start-slide {
        transform: translate(-44.7vw);
        opacity: 1;
    }
    .next-slide {
        transform: translate(1.2vw);
        opacity: 1;
    }
    .next-btn {
        cursor: pointer;
        position: absolute;
        top: 13vw;
        left: 68vw;
        width: 2.05vw;
        height: 1.852vw;
    }
    .line-one {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 2.183vw;
        margin-bottom: 0.661vw;
        align-items: center;
        height: 3.042vw;
    }
    .line-two {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .border-div {
        width: 45.675vw;
        height: 30.82vw;
        margin-left: 27vw;
        margin-top: 4.233vw;
        border: 0.198vw solid #7cc1ff;
        border-left: none;
    }
    .hero-div {
        width: 24.008vw;
        height: 15.41vw;
        background: linear-gradient(285.51deg, #3382c0 0%, #66bafb 99.38%);
        top: 0vw;
        left: 72.553vw;
        border-radius: 0vw 2vw 0vw 0vw;
        border: 0.198vw solid #7cc1ff;
        position: absolute;
    }
    .raised-div {
        width: 24.008vw;
        height: 15.41vw;
        background: linear-gradient(74.12deg, #00204b 1.5%, #00429b 99.49%);
        top: 15.4vw;
        left: 72.553vw;
        border-radius: 0vw 0vw 2vw 0vw;
        border: 0.198vw solid #7cc1ff;
        border-top: none;
        position: absolute;
    }
    .hero-text {
        font-size: 1.653vw;
        margin-top: 6.746vw;
        text-align: center;
        font-weight: 600;
        color: white;
    }
    /*Slider*/
    .sli {
        width: 19.577vw;
        margin-right: 3vw;
        scroll-snap-align: start;
        transition: transform 1s, opacity 2s;
    }
    .slider-img {
        width: 19.444vw;
        height: 14.352vw;
        border-radius: 0.331vw;
    }
    .slider-img img {
        width: 100%;
        height: 100%;
        border-radius: 0.331vw;
    }
    .name-text {
        font-size: 1.653vw;
        font-weight: 500;
        width: 13vw;
        line-height: 1.7vw;
    }
    .date {
        font-size: 1.058vw;
        color: rgba(0, 32, 75, 0.7);
        line-height: 1.2vw;
    }
    .logo-img {
        text-align: right;
        /* margin-right: 1vw; */
        height: auto;
    }
    .logo-img img {
        width: 100%;
    }
    .logo-text {
        font-size: 1.19vw;
        color: #3c74c0;
        /* line-height: 1.2vw;
        margin-right: 1vw; */
    }
    .slider::-webkit-scrollbar {
        display: none;
    }
    .name-text,
    .logo-text,
    .date,
    p {
        margin-bottom: 0vw;
    }
    .slider {
        display: flex;
        margin-top: -26vw;
        width: 67vw;
        height: 30.82vw;
        scroll-behavior: smooth;
        overflow: hidden;
        margin-left: 0.198vw;
    }
</style>
